import { Box, Grid, Typography } from "@mui/material";
import React, { useState, useRef, useEffect } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import "./TrainingListingDetails.scss";
import { styled } from "@mui/material/styles";
import green_icon from "../../globals/assets/green_computer.svg";
import COPY from "../../Images/clone.svg";
import CLOSE from "../../Images/close.svg";
import Switch from "@mui/material/Switch";
import Stack from "@mui/material/Stack";
import TrainingGridListing from "../TrainingGridListing";
import TrainingListingFilter from "../TrainingListingFilter";
import { toast } from "react-toastify";
import * as XLSX from "xlsx";
import WeekDays from "../weekDays";
import { useDispatch, useSelector } from "react-redux";
import CONSTANTS from "../../globals/common_utilities/constant";
import moment from "moment";
import { API, CONSTANTS_DATA, APP_ROUTES } from "../../globals/constants";
import CONSTANTURL from "../../globals/common_utilities/constanturls";
import CancelledModal from "../CancelledModal/CancelledModal";
import Cookies from "universal-cookie";
import api_call from "../../globals/common_utilities/axios_old";
import MultiLine_Spinner from "../multiline_spinner/Multiline_spinner";
import Upload from "../../Images/Icon_Upload.svg";
import Button from "../common/Button";
import Tooltip from "../common/Tooltip";
import Info from "../../Images/yellow_info_icon.svg";
import Google from "../../Images/google-cloud.svg";
import Aws from "../../Images/aws-cloud.svg";
import CsvDownloader from "react-csv-downloader";

const TrainingListingDetails = (props) => {
  console.log("props", props);
  const { state } = useLocation();
  const navigate = useNavigate();
  const [selectedFile, setSelectedFile] = useState();
  const [uploadData, setUploadData] = useState([]);
  const [errorMessage, setErrorMessage] = useState([]);
  const [uploadFilterData, setuploadFilterData] = useState([]);
  const [training, setTraining] = useState(
    props?.training || state?.training || []
  );
  const [trainingList, setTrainingList] = useState(
    props?.trainingList || state?.trainingList || []
  );
  const [redirect, setRedirect] = useState(state?.redirect || []);
  const [ismachinelist, setIsmachineList] = useState();
  const [showCancelledModal, setShowCancelledModal] = useState();
  const [trainingDeatils, setTrainingDetails] = useState();
  const [isLoading, setIsloading] = useState(false);
  const [cancelStatus, setCancelStatus] = useState(false);

  const { loginResponse, loading, error } = useSelector((state) => {
    console.log("state-------->>>", state);
    return state.login;
  });
  const cookies = new Cookies();
  const {
    id,
    name,
    device_id,
    studio_id,
    role_id,
    role_code,
    token,
    token_uniq_id,
    email_id,
    username,
    is_email_verify,
  } = cookies.get("loginData");
  console.log("trainingList==========>>>>>>>>", trainingList);
  const students_samples_files_JSON = [
    {
      name: "John Doe",
      email_id: "abc@gmaildummy.com",
      is_machine_required: "yes",
    },
  ];

  function validateColumFile(csv) {
    var lines = csv.split("\n");
    let validation = true;
    const re =
      /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    const contact_regex = /^[0-9]*(?:\.\d{1,2})?$/;
    const location_regex =
      /^(?=[a-zA-Z~@#$^*()_+=[\]{}|\\,.?: -]*$)(?!.*[<>'"/;`%])/;
    const script_regex =
      /^(?=[a-zA-ZÀ-žäöüÄÖÜß0-9~@#$&^*/;`%()_+=[\]{}|\\,.?: -]*$)(?!.*[<>'"])/;
    var headers = lines[0].split(",");

    for (var i = 1; i < lines.length - 1; i++) {
      var obj = {};
      var currentline = lines[i].split(",");

      for (var k = 0; k < headers.length; k++) {
        obj[headers[k]] = currentline[k];
      }
      if (obj.email_id === "") {
        validation = false;

        setErrorMessage(`email field data incorrect or empty`);
        toast.error(`email field data incorrect or empty`, {
          position: "bottom-right",
          autoClose: 3000,
          hideProgressBar: true,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          style: { background: "#000", color: "#ffffff" },
        });

        break;
      } else if (obj.is_machine_required === "") {
        validation = false;

        setErrorMessage(`is_machine_required field data incorrect or empty`);
        toast.error(`is_machine_required field data incorrect or empty`, {
          position: "bottom-right",
          autoClose: 3000,
          hideProgressBar: true,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          style: { background: "#000", color: "#ffffff" },
        });
        break;
      } else if (!re.test(obj.email_id.trim())) {
        validation = false;

        setErrorMessage(`email field data incorrect`);
        toast.error(`email field data incorrect`, {
          position: "bottom-right",
          autoClose: 3000,
          hideProgressBar: true,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          style: { background: "#000", color: "#ffffff" },
        });
        break;
      } else if (!script_regex.test(obj.name.trim())) {
        validation = false;

        setErrorMessage(`Name field data incorrect `);
        toast.error(`Name field data incorrect `, {
          position: "bottom-right",
          autoClose: 3000,
          hideProgressBar: true,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          style: { background: "#000", color: "#ffffff" },
        });
        break;
      } else if (
        obj.is_machine_required.trim() !== "yes" &&
        obj.is_machine_required.trim() !== "no" &&
        obj.is_machine_required.trim() !== "Yes" &&
        obj.is_machine_required.trim() !== "No" &&
        obj.is_machine_required.trim() !== "YES" &&
        obj.is_machine_required.trim() !== "NO"
      ) {
        validation = false;

        setErrorMessage(`is machine required field data incorrect `);
        toast.error(`is machine required field data incorrect `, {
          position: "bottom-right",
          autoClose: 3000,
          hideProgressBar: true,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          style: { background: "#000", color: "#ffffff" },
        });
        break;
      } else {
        validation = true;
      }
    }

    //return result; //JavaScript object
    return validation; //JSON
  }

  const convertToJson = (csv) => {
    var lines = csv.split("\n");

    var result = [];

    var headers = lines[0].split(",");

    for (var i = 1; i < lines.length - 1; i++) {
      var obj = {};
      var currentline = lines[i].split(",");
      for (var j = 0; j < headers.length; j++) {
        obj[headers[j]] = currentline[j]?.trim();
      }
      const arr1 = uploadData.filter((d) => d.email_id === obj.email_id);
      if (obj.email_id === "" || arr1.length > 0) {
      } else {
        obj.is_machine_required === "yes" ||
        obj.is_machine_required === "Yes" ||
        obj.is_machine_required === "YES"
          ? (obj.is_machine_required = true)
          : (obj.is_machine_required = false);
        let temp = obj.email_id;
        obj.email_id = temp?.trim();
        result.push(obj);
      }
    }
    const key = "email_id";
    //return result; //JavaScript object
    const arrayUniqueByKey = [
      ...new Map(result.map((item) => [item[key], item])).values(),
    ];
    return JSON.parse(JSON.stringify(arrayUniqueByKey)); //JSON
  };

  function validateFile(csv) {
    var lines = csv.split("\n");
    let validation = true;

    var result = ["name", "email_id", "is_machine_required"];

    var headers = lines[0].split(",");
    if (headers.length === result.length) {
      for (var j = 0; j < result.length; j++) {
        if (headers.includes(result[j])) {
          validation = true;
        } else {
          setErrorMessage(`${result[j]} field is missing`);
          validation = false;
          break;
        }
      }
    } else {
      toast.error(
        `Invalid file format, Please download sample file and upload student's data`,
        {
          position: "bottom-right",
          autoClose: 3000,
          hideProgressBar: true,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          toastId: "invalidfields",
          style: { background: "#000", color: "#ffffff" },
        }
      );
      validation = false;
    }
    return validation; //JSON
  }

  function openfile() {
    document.getElementById("file-upload").click();
  }

  const gotoPreviousPage = () => {
    navigate(APP_ROUTES.TRAINING_LISTING, { replace: true });
  };
  async function submit(data) {
    let bodyParam = {};
    bodyParam = {
      title: training?.title,
      session_end_date: training?.session_end_date,
      session_start_date: training?.session_start_date,
      instructor_id: training?.instructor_id,
      studio_id: training?.studio_id,
      student: data,
      host: training?.host,
      cloud_type: training?.cloud_type,
    };

    let response = "";
    if (role_code === CONSTANTS.ROLE.ADMIN) {
      response = await api_call(
        "POST",
        `${
          CONSTANTURL[process.env.REACT_APP_CUSTOM_ENV].TRAINING +
          API.END_POINTS.UPDATE_TRAINING
        }?id=${training?.id}`,
        // `${API.BASE_URL.TRAINING+API.END_POINTS.UPDATE_TRAINING}?id=${training?.id}`,
        {},
        {},
        bodyParam
      );
    } else if (role_code === CONSTANTS.ROLE.STUDIO_ADMIN) {
      response = await api_call(
        "POST",
        `${
          CONSTANTURL[process.env.REACT_APP_CUSTOM_ENV].TRAINING +
          API.END_POINTS.TRAINING_STUDIO_ADMIN_UPDATE
        }?id=${training?.id}`,
        // `${API.BASE_URL.TRAINING+API.END_POINTS.TRAINING_STUDIO_ADMIN_UPDATE}?id=${training?.id}`,
        {},
        {},
        bodyParam
      );
    } else if (role_code === CONSTANTS.ROLE.INSTRUCTOR) {
      response = await api_call(
        "POST",
        `${
          CONSTANTURL[process.env.REACT_APP_CUSTOM_ENV].TRAINING +
          API.END_POINTS.TRAINING_INSTRUCTOR_UPDATE
        }?id=${training?.id}`,
        // `${API.BASE_URL.TRAINING+API.END_POINTS.TRAINING_INSTRUCTOR}?id=${training?.id}`,
        {},
        {},
        bodyParam
      );
    }
    if (response.status === CONSTANTS.STATUS.OK) {
      // this.props.loadSelectedList(training?.id);
      // this.setState({ isLoading: false });
      // const { history } = this.props;
      toast.success("Data uploaded successfully", {
        position: "bottom-right",
        autoClose: 3000,
        hideProgressBar: true,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        style: { background: "#000", color: "#ffffff" },
      });
    } else {
      // this.setState({ isLoading: false });
      toast.error("Data upload unsuccessfully", {
        position: "bottom-right",
        autoClose: 3000,
        hideProgressBar: true,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        style: { background: "#000", color: "#ffffff" },
      });
    }
  }

  function onFileChange(e) {
    // setState({ selectedFile: e.target.files[0] });
    setSelectedFile({ selectedFile: e.target.files[0] });
    var f = e.target.files[0];
    var file = e.target.files[0];
    var filename = file.name;
    var regex = new RegExp("(.*?).(csv)$");

    if (regex.test(filename)) {
      const reader = new FileReader();

      reader.onload = async (evt) => {
        // evt = on_file_select event
        /* Parse data */
        const bstr = evt.target.result;
        const wb = XLSX.read(bstr, { type: "binary" });
        /* Get first worksheet */
        const wsname = wb.SheetNames[0];
        const ws = wb.Sheets[wsname];
        /* Convert array of arrays */
        const data = XLSX.utils.sheet_to_csv(ws, { header: 1 });
        // this.convertToJson(data)
        console.log(
          "validate columns",
          validateFile(data),
          validateColumFile(data)
        );
        if (validateFile(data) && validateColumFile(data)) {
          toast.success("File uploaded successfully", {
            position: "bottom-right",
            autoClose: 3000,
            hideProgressBar: true,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            style: { background: "#000", color: "#ffffff" },
          });
          let uploadDataTemp = [...convertToJson(data)];
          await setUploadData([...uploadDataTemp]);
          let arr1 = ismachinelist;
          let arr2 = uploadDataTemp;
          let temp = arr1.concat(arr2);
          await setIsmachineList([...temp]);
          console.log("uploadDataTemp---222222222------->>>", [
            ...uploadDataTemp,
          ]);
          await submit([...uploadDataTemp]);
          loadTraining();
          // await setuploadFilterData(uploadData);
          // document.getElementById("file-upload").value = "";
        } else {
        }
      };
      reader.readAsBinaryString(f);
    } else {
      toast.error(`Please select csv file`, {
        position: "bottom-right",
        autoClose: 3000,
        hideProgressBar: true,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        style: { background: "#000", color: "#ffffff" },
      });
    }
    e.target.value = null;
    // ReactGA.event(
    //   this.ROLE_CODE === CONSTANTS.ROLE.ADMIN
    //     ? GA_TAG_LIST.ADMINTRAINING.BROWSE
    //     : GA_TAG_LIST.STUDIOADMINTRAINING.BROWSE
    // );
  }

  const AntSwitch = styled(Switch)(({ theme }) => ({
    width: 28,
    height: 16,
    padding: 0,
    display: "flex",
    "&:active": {
      "& .MuiSwitch-thumb": {
        width: 15,
      },
      "& .MuiSwitch-switchBase.Mui-checked": {
        transform: "translateX(9px)",
      },
    },
    "& .MuiSwitch-switchBase": {
      padding: 2,
      "&.Mui-checked": {
        transform: "translateX(12px)",
        color: "#0C0D16",
        "& + .MuiSwitch-track": {
          opacity: 1,
          backgroundColor: theme.palette.mode === "dark" ? "white" : "white",
        },
      },
    },
    "& .MuiSwitch-thumb": {
      boxShadow: "0 2px 4px 0 rgb(0 35 11 / 20%)",
      width: 12,
      height: 12,
      borderRadius: 6,
      transition: theme.transitions.create(["width"], {
        duration: 200,
      }),
    },
    "& .MuiSwitch-track": {
      borderRadius: 16 / 2,
      opacity: 1,
      backgroundColor:
        theme.palette.mode === "dark" ? "rgba(0,0,0,.25)" : "rgba(0,0,0,.25)",
      boxSizing: "border-box",
    },
  }));

  const gotolistingPage = (event) => {
    // if (state.redirect === 'dashboard') {
    // 	navigate('/dashboard', {
    // 		state: { id: 7, color: 'green' },
    // 	});
    // } else {
    // 	props?.showDetailPage();
    // event.stopPropagation();
    // console.log('event.stopPropagation()------------>>', event);
    // navigate(APP_ROUTES.TRAINING_LISTING, {
    // 	state: { id: 7, color: 'green' },
    // });

    redirect == "dashboard"
      ? navigate("/dashboard", {
          state: { id: 7, color: "green" },
        })
      : props?.showDetailPage();
    // }
  };

  const getselectedTraining = (data) => {
    setTraining(data);
  };

  const loadSelectedStudent = async (e) => {
    console.log("training---------->>", training);
    let queryParam =
      role_code === "STUDIO_ADMIN"
        ? { studio_id: studio_id }
        : role_code === "INSTRUCTOR"
        ? { instructor_id: id }
        : { instructor_id: id };
    const selectedResponse = await api_call(
      "GET",
      `${
        CONSTANTURL[process.env.REACT_APP_CUSTOM_ENV].TRAINING +
        API.END_POINTS.GET_STUDENT_TRAINING_LISTING
      }?tid=${training?.id}&is_intrested=Default&is_active=true&role_id=3`,
      queryParam
      // `${API.BASE_URL.TRAINING+API.END_POINTS.GET_STUDENT_TRAINING_LISTING}?tid=${training?.id}&is_intrested=Default&is_active=true&role_id=3`
    );
    const acceptedResponse = await api_call(
      "GET",
      `${
        CONSTANTURL[process.env.REACT_APP_CUSTOM_ENV].TRAINING +
        API.END_POINTS.GET_STUDENT_TRAINING_LISTING
      }?tid=${training?.id}&is_intrested=Accepted&is_active=true&role_id=3`,
      queryParam
      // `${API.BASE_URL.TRAINING+API.END_POINTS.GET_STUDENT_TRAINING_LISTING}?tid=${training?.id}&is_intrested=Accepted&is_active=true&role_id=3`
    );

    console.log("setIsmachineList---------->>", selectedResponse);

    if (selectedResponse.status === CONSTANTS.STATUS.OK) {
      // setIsmachineList([
      //   ...selectedResponse?.data?.data?.rows,
      //   ...acceptedResponse?.data?.data?.rows,
      // ]);
    } else {
      // setIsmachineList([]);
    }
  };
  const loadTraining = async () => {
    const response = await api_call(
      "get",
      `${
        CONSTANTURL[process.env.REACT_APP_CUSTOM_ENV].TRAINING +
        API.END_POINTS.TRAINING_BY_ID
      }?tid=${training?.id}`
    );
    if (response.status === 200) {
      console.log("check responsep------", response.data.data);
      setTrainingDetails(response.data.data);

      console.log("gjghxgjhghgjh------", response.data.data.users_trainings);
      let temp = response.data.data.users_trainings;
      let student_data = temp.map((item) => {
        return {
          is_machine_required: item.is_machine_required,
          name: item.student.name,
          contact_no: item.student.contact_no,
          country_name: item.student.country_name,
          email_id: item.student.email_id,
          location: item.student?.location?.code,
          short_information: item.student.short_information,
          id: item.student_id,
          user_id: item.id,
        };
      });
      await setIsmachineList([...student_data]);
      await setUploadData([...student_data]);
      console.log("student_data", student_data);
    }
  };
  const closemodal = () => {
    setShowCancelledModal(false);
  };
  const handleButtonClick = () => {
    document.getElementById("file-upload").click();
  };
  const CancelledTraining = async ({ cancelReason = "" }) => {
    let body = {
      status: CONSTANTS_DATA.CANCLE,
      training_id: training?.id,
      cancel_by: id,
      reason: cancelReason,
    };
    const response = await api_call(
      "POST",
      `${
        CONSTANTURL[process.env.REACT_APP_CUSTOM_ENV].TRAINING +
        API.END_POINTS.CANCELLED_TRAINING
      }`,
      {},
      {},
      body
    );
    if (response.status === 200) {
      toast.success(`success`, {
        position: "bottom-right",
        autoClose: 3000,
        hideProgressBar: true,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        style: { background: "#000", color: "#ffffff" },
      });
      closemodal();
      training.status_colour = {
        color: "#ed0c0c",
        background: "#893a3a59",
        status: "Cancelled Training",
      };
    }
  };
  const deleteStudent = async (trainingId, studentId, emailId) => {
    console.log("check email----", trainingId, studentId, emailId);

    let delete_email = ismachinelist.filter(
      (item) => item.email_id === emailId
    );
    // if (!delete_email.id) {
    //   let data = ismachinelist.filter((item) => item.email_id !== emailId);
    //   setIsmachineList([...data]);
    // } else {
    const response = await api_call(
      "DELETE",
      `${
        CONSTANTURL[process.env.REACT_APP_CUSTOM_ENV].STUDENT +
        API.END_POINTS.STUDENT_USER_DELETE
      }`,
      {
        ids: JSON.stringify([studentId]),
        t_id: trainingId,
      },
      {},
      {}
    );
    // setIsloading(true)
    if (response.status === 200) {
      // setIsloading(false)
      let data = ismachinelist.filter((item) => item.id !== studentId);
      setIsmachineList([...data]);
      setUploadData([...data]);
    } else {
    }
    // }
  };
  const createSession = (action) => {
    navigate(APP_ROUTES.ROUTE_CREATESESSION, {
      state: {
        trainingData: training,
        training: training.id,
        action: action,
      },
    });
  };
  const handleCheck = async (index, trainingId) => {
    let data = ismachinelist;
    console.log("check the data saved---", data);
    data[index].is_machine_required = !data[index].is_machine_required;
    setIsmachineList([...data]);
    let bodyParam = {
      approved_by: role_code === "STUDIO_ADMIN" ? studio_id : id,
      is_machine_required: data[index].is_machine_required,
      user_training_id: trainingId,
    };
    let response = await api_call(
      "post",
      `${
        CONSTANTURL[process.env.REACT_APP_CUSTOM_ENV].TRAINING_EXTEND +
        API.END_POINTS.IS_MACHINE_REQUIRED
      }`,
      {},
      {},
      bodyParam
    );
    if (response.status === 200) {
    }
  };

  useEffect(() => {
    loadSelectedStudent();
    loadTraining();
  }, [training]);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return (
    <>
      <Box className="TrainingDetailsListMainContainer">
        {console.log(
          "training_data_check----",
          props?.training?.session_end_date,
          moment(props?.training?.session_end_date).format("hh:mm")
        )}
        <Grid container columnSpacing={2}>
          <Grid item xs={12} sm={12} md={12} lg={8}>
            <div className="detailsContainer">
              <Box className="childDetailsContainer">
                <Box className="containerMargin">
                  <Grid container>
                    <Grid item xs={12} sm={6} md={6} lg={7}>
                      <div className="set-training-heading">
                        <Box>
                          {training?.cloud_type === "GCP" ? (
                            <img
                              src={Google}
                              height={20}
                              className="set-logo-mar"
                            />
                          ) : (
                            <img
                              src={Aws}
                              height={20}
                              className="set-logo-mar"
                            />
                          )}
                        </Box>
                        <Box className="large_f_bold">
                          Training Name -{training?.title}
                        </Box>
                      </div>
                    </Grid>
                    <Grid
                      item
                      xs={12}
                      sm={6}
                      md={6}
                      lg={5}
                      container
                      direction={"row"}
                      justifyContent={"space-around"}
                    >
                      <span
                        className="TrainingDetailsUpcoming medium_f_bold"
                        style={{
                          color: training?.status_colour?.color,
                          background: training?.status_colour?.background,
                        }}
                      >
                        {training?.status_colour?.status}
                      </span>
                      {/* <Tooltip
                        title={
                          "You can clone this training session with same students  "
                        }
                        placement="right"
                        arrow={true}
                        content={
                          <img
                            src={COPY}
                            height="30px"
                            width="30px"
                            style={{
                              border: "1px solid #3DAFF8",
                              borderRadius: "5px",
                              cursor: "pointer",
                            }}
                            onClick={() => createSession("copy")}
                          />
                        }
                      ></Tooltip> */}

                      <img
                        src={CLOSE}
                        height="30px"
                        width="30px"
                        style={{ cursor: "pointer" }}
                        onClick={gotolistingPage}
                      />
                    </Grid>
                  </Grid>
                </Box>
                <Box className="containerMargin">
                  <Grid container columnSpacing={4}>
                    <Grid item xs={12} sm={6} md={6} lg={4}>
                      <Box className="medium_f training_details_page_instructor_name">
                        Instuctor Name -
                        <span className="medium_f_bold">
                          {training?.user?.name}
                        </span>
                      </Box>
                    </Grid>
                    <Grid item xs={12} sm={6} md={6} lg={4}>
                      <Box className="medium_f">
                        Training Centre -
                        <span className="medium_f_bold">
                          {training?.studio?.studio_name}
                        </span>
                      </Box>
                    </Grid>
                    <Grid item xs={0} sm={0} md={6} lg={4}></Grid>
                  </Grid>
                </Box>
                <Box className="containerMargin">
                  <Grid container columnSpacing={4}>
                    <Grid item xs={10.5} sm={10.5} md={10.5} lg={10.5}>
                      <Box className="small_f">{training?.description}</Box>
                    </Grid>
                    {(training?.status === "in-progress" ||
                      training?.status === "pending") && (
                      <Grid item xs={12} sm={1.5} md={1.5} lg={1.5}>
                        <Box className="trainingDetailsstartIn">
                          <Grid
                            container
                            direction="row"
                            justifyContent="center"
                            alignContent="center"
                          >
                            <Grid xs={12} className="small_f">
                              start in
                            </Grid>
                            <Grid xs={12} className="larger_f_bold">
                              {training?.diffs}
                            </Grid>

                            <Grid xs={12} className="small_f">
                              Days
                            </Grid>
                          </Grid>
                          <Box></Box>
                          <Box></Box>
                          <Box></Box>
                        </Box>
                      </Grid>
                    )}
                  </Grid>
                </Box>
                <Box className="containerMargin">
                  <Grid container rowSpacing={2}>
                    <Grid item xs={12} sm={12} md={6} lg={7}>
                      <Box className="startEndTrainingDetails">
                        <Grid container columnSpacing={8}>
                          <Grid item xs={12} sm={9} md={9} lg={9}>
                            {console.log(
                              "lllllllkkkkkk-----",
                              moment("2023-01-23T17:00:00.000Z").format(
                                "HH:mm"
                              ),
                              moment("2023-01-23T18:00:00.000Z").format("HH:mm")
                            )}
                            <Box className="small_f_bold">
                              {training?.startDate} - {training?.endDate} -
                              {training?.startTime} to {training?.endTime}
                            </Box>
                            <Box className="TrainingDetailsactiveDaysContainer">
                              <WeekDays
                                days={training?.days}
                                training_dates={training?.training_dates}
                                cloudType={training?.cloud_type}
                              />
                            </Box>
                          </Grid>
                          <Grid item xs={12} sm={3} md={3} lg={3}>
                            <Grid
                              container
                              direction="column"
                              justifyContent="center"
                              alignItems="center"
                              className="noOfDaysTraining"
                            >
                              <Grid className="largeFont larger_f_bold">
                                {training?.training_dates.length}
                              </Grid>
                              <Grid className="medium_f">Schedule</Grid>

                              <Grid className="small_f">Training</Grid>
                            </Grid>
                          </Grid>
                        </Grid>
                      </Box>
                    </Grid>
                    <Grid
                      item
                      xs={12}
                      sm={12}
                      md={6}
                      lg={5}
                      className="TrainingDetailsButtonContainer"
                    >
                      <Box>
                        <Grid container justifyContent="space-evenly">
                          {showCancelledModal && (
                            <CancelledModal
                              closeModal={closemodal}
                              CancelledTraining={CancelledTraining}
                            />
                          )}
                          {training?.training_type === "rightnow" ? (
                            ""
                          ) : (
                            <Grid item>
                              <input
                                type="button"
                                value="Cancel session"
                                className="TrainingDetialsCancelSessionButton small_f_bold"
                                onClick={() => setShowCancelledModal(true)}
                                disabled={
                                  new Date(training?.session_end_date) <
                                    new Date() ||
                                  training?.status_colour?.status ===
                                    "Cancelled Training" ||
                                  training?.status === "completed" ||
                                  training?.status === "running" ||
                                  training?.status === "failed" ||
                                  training?.status === "cancel"
                                    ? true
                                    : false
                                }
                              />
                            </Grid>
                          )}
                          {training?.cloud_type === "GCP" ? (
                            ""
                          ) : (
                            <Grid item>
                              <input
                                type="button"
                                value="Reschedule"
                                className="TrainingDetialsRescheduleButton small_f_bold"
                                onClick={() => createSession("reschedule")}
                                disabled={
                                  new Date(training?.session_end_date) <
                                    new Date() ||
                                  training?.status_colour?.status ===
                                    "Cancelled Training" ||
                                  training?.status === "completed" ||
                                  training?.status === "running" ||
                                  training?.status === "cancel"
                                    ? true
                                    : false
                                }
                                // disabled ={new Date(training?.session_end_date) < new Date() ? true : false}
                              />
                            </Grid>
                          )}
                          {training?.cloud_type === "GCP" ? (
                            ""
                          ) : (
                            <Grid marginTop="1%">
                              <Tooltip
                                title={
                                  "You will not be able to cancel or reschedule the running training session."
                                }
                                placement="right"
                                arrow={true}
                                content={<img src={Info} />}
                              ></Tooltip>
                            </Grid>
                          )}
                          {false && (
                            <Grid item>
                              <input
                                type="button"
                                value="VM Credentail"
                                className="TrainingDetialsVMCredButton small_f_bold"
                              />
                            </Grid>
                          )}
                        </Grid>
                      </Box>
                    </Grid>
                  </Grid>
                </Box>
                <Box className="machineRequiredContainer">
                  <Grid container rowSpacing={2} columnSpacing={2}>
                    {ismachinelist &&
                      ismachinelist.map((data, index) => {
                        return (
                          <>
                            <Grid item xs={12} sm={6} md={4} lg={4}>
                              {console.log("ttttt00000---", data)}
                              <Box className="machineRequiredblock">
                                <Grid container>
                                  <Grid item xs={12} sm={12} md={2} lg={2}>
                                    <img src={green_icon} />
                                  </Grid>
                                  <Grid item xs={12} sm={12} md={10} lg={10}>
                                    <Box className="machineRequiredDetails">
                                      <Box className="medium_f">
                                        {data?.name ? data?.name : "VM_User"}
                                      </Box>
                                      {/* <Box className="small_f">
                                        <Tooltip
                                          title={data?.email_id}
                                          placement="right"
                                          arrow={true}
                                          content={
                                            data?.email_id.length > 18
                                              ? `${data?.email_id.substring(
                                                0,
                                                13
                                              )}...`
                                              : data?.email_id
                                          }
                                        ></Tooltip>
                                      </Box> */}
                                      <Box
                                        className="is_machine_close"
                                        onClick={() =>
                                          training?.training_type ===
                                            "rightnow" ||
                                          new Date(training?.session_end_date) <
                                            new Date() ||
                                          training?.status === "completed" ||
                                          training?.status === "running" ||
                                          training?.status === "cancel" ||
                                          (training?.cloud_type === "GCP" &&
                                            training?.status === "pending") ||
                                          training?.cloud_type === "GCP"
                                            ? console.log(
                                                "Hit delete",
                                                training?.cloud_type,
                                                training?.status
                                              )
                                            : deleteStudent(
                                                training?.id,
                                                data?.id,
                                                data.email_id
                                              )
                                        }
                                      >
                                        <img
                                          src={CLOSE}
                                          height="20px"
                                          width="20px"
                                          style={{
                                            cursor:
                                              new Date(
                                                training?.session_end_date
                                              ) < new Date() ||
                                              training?.status ===
                                                "completed" ||
                                              training?.status === "cancel" ||
                                              (training?.status === "pending" &&
                                                training?.cloud_type ===
                                                  "GCP") ||
                                              training?.cloud_type === "GCP"
                                                ? "not-allowed"
                                                : "pointer",
                                            margin: "4px",
                                          }}
                                          // onClick={() =>
                                          //   new Date(training?.session_end_date) <
                                          //     new Date() ||
                                          //   training?.status === "completed" ||
                                          //   training?.status === "running" ||
                                          //   training?.status === "cancel"
                                          //     ? ""
                                          //     : deleteStudent(
                                          //         training?.id,
                                          //         data.id,
                                          //         data.email_id
                                          //       )
                                          // }
                                        />
                                      </Box>
                                      {/* <Box className="machinereuiredStatus small_f">
                                        Approved
                                      </Box> */}
                                    </Box>
                                  </Grid>
                                </Grid>
                                <Box className="machinerequiredtoggle">
                                  <Grid container columnSpacing={0.5}>
                                    <Grid item xs={7} sm={7} md={7} lg={7}>
                                      <Box className="smallest_f">
                                        Machine Require
                                      </Box>
                                    </Grid>
                                    <Grid item xs={5} sm={5} md={5} lg={5}>
                                      <Box>
                                        <Stack
                                          direction="row"
                                          spacing={1}
                                          alignItems="center"
                                        >
                                          <span className="smallest_f">No</span>
                                          <AntSwitch
                                            checked={data?.is_machine_required}
                                            inputProps={{
                                              "aria-label": "ant design",
                                            }}
                                            onChange={() =>
                                              handleCheck(index, data?.user_id)
                                            }
                                            disabled={
                                              training?.training_type ===
                                                "rightnow" ||
                                              new Date(
                                                training?.session_end_date
                                              ) < new Date() ||
                                              training?.status ===
                                                "completed" ||
                                              training?.status === "running" ||
                                              training?.status === "cancel" ||
                                              training?.cloud_type === "GCP"
                                                ? true
                                                : false
                                            }
                                          />
                                          <span className="smallest_f">
                                            Yes
                                          </span>
                                        </Stack>
                                      </Box>
                                    </Grid>
                                  </Grid>
                                </Box>
                              </Box>
                            </Grid>
                          </>
                        );
                      })}
                  </Grid>
                </Box>
                {/* <Grid container rowSpacing={2}>
                  <Box className="browseContainer">
                    <label className="TrainingDetialsbrowseButton">
                      Browse
                      <input
                        type="file"
                        name="B"
                        accept=".csv"
                        onChange={onFileChange}
                      />
                    </label>
                  </Box>
                </Grid> */}
                {/* Remove this conditions after update starts working */}
                {training?.cloud_type !== "GCP" ? (
                  <Stack direction="row">
                    <Grid
                      container
                      className={
                        new Date(training?.session_end_date) < new Date() ||
                        training?.status === "completed" ||
                        training?.status === "cancel" ||
                        (training?.cloud_type === "GCP" &&
                          training?.status === "pending")
                          ? "disableBrowseContainer"
                          : "browseContainer"
                      }
                    >
                      <Grid
                        item
                        xs={12}
                        sm={12}
                        md={6}
                        lg={8}
                        xl={8}
                        className="browse_area"
                        onClick={() =>
                          training?.cloud_type === "GCP"
                            ? new Date(training?.session_end_date) <
                                new Date() ||
                              training?.status === "completed" ||
                              training?.status === "cancel" ||
                              training?.status === "pending"
                              ? ""
                              : handleButtonClick()
                            : new Date(training?.session_end_date) <
                                new Date() ||
                              training?.status === "completed" ||
                              training?.status === "running" ||
                              training?.status === "cancel"
                            ? ""
                            : handleButtonClick()
                        }
                        onChange={(e) =>
                          training?.cloud_type === "GCP"
                            ? new Date(training?.session_end_date) <
                                new Date() ||
                              training?.status === "completed" ||
                              training?.status === "cancel" ||
                              training?.status === "pending"
                              ? ""
                              : onFileChange(e)
                            : new Date(training?.session_end_date) <
                                new Date() ||
                              training?.status === "completed" ||
                              training?.status === "running" ||
                              training?.status === "cancel"
                            ? ""
                            : onFileChange(e)
                        }
                      >
                        <img
                          src={Upload}
                          className="upload_img"
                          // onClick={() => handleButtonClick()}
                          // onChange={(e) => onFileChange(e)}
                        ></img>
                        <input
                          id="file-upload"
                          onChange={(e) => onFileChange(e)}
                          accept=".csv"
                          type="file"
                          name="fileUpload"
                          style={{ display: "none" }}
                        />
                        <div
                          for="file-upload"
                          onChange={(e) => onFileChange(e)}
                          className=""
                        >
                          <Typography
                            variant="h6"
                            id="file-drag"
                            className="browse_heading"
                            // onClick={() => handleButtonClick()}
                            // onChange={(e) => onFileChange(e)}
                          >
                            Browse to upload more student in this training
                          </Typography>
                        </div>
                      </Grid>
                      <Grid item xs={12} sm={12} md={6} lg={4} xl={4}>
                        <CsvDownloader
                          //   // id="link"
                          //   // href="https://unreal-engine-ui.s3.ap-south-1.amazonaws.com/students_samples_files.csv"
                          //   // download
                          // >

                          id="export_csv"
                          filename="student_sample_files.csv"
                          separator=","
                          columns={[
                            { displayName: "name", id: "name" },
                            {
                              displayName: "email_id",
                              id: "email_id",
                            },
                            {
                              displayName: "is_machine_required",
                              id: "is_machine_required",
                            },
                          ]}
                          // wrapColumnChar=""
                          datas={[
                            {
                              name: "John Doe",
                              email_id: "abc@gmaildummy.com",
                              is_machine_required: "yes",
                            },
                          ]}
                        >
                          <button
                            id="file-drag"
                            className="sample_file_margin_details"
                          >
                            Download Sample file
                          </button>
                        </CsvDownloader>
                      </Grid>
                    </Grid>
                  </Stack>
                ) : (
                  <></>
                )}
              </Box>
            </div>
          </Grid>
          <Grid item xs={12} sm={12} md={12} lg={4}>
            <Box className="detailsContainer">
              <Grid container columnSpacing={4}>
                {trainingList.map((training) => {
                  return (
                    <Grid item xs={12} sm={12} md={6} lg={12}>
                      <TrainingGridListing
                        training={training}
                        onClick={getselectedTraining}
                      />
                    </Grid>
                  );
                })}
              </Grid>
            </Box>
          </Grid>
        </Grid>
      </Box>
      {isLoading && <MultiLine_Spinner />}
    </>
  );
};

export default TrainingListingDetails;
